export enum PaymentStatusEnum {
  Pending = 1,
  Approved = 2,
  Rejected = 3,
  Cancelled = 4,
  Closed = 5,
  TranscriptionRequired,
  TreasurerApprovalRequired,
  FinalApprovalRequired,
  SalesOfficerApprovalRequired,
}
export enum PaymentModeTypeEnum {
  Automatic = 1,
  Manual = 2,
}
